/**
 * Solomon Islands dollar.
 */
export var SBD = {
  code: 'SBD',
  base: 10,
  exponent: 2
};